module.exports = __webpack_public_path__ + "img/pricing.0081025e.png";